// extracted by mini-css-extract-plugin
export default {"slideContainer":"_38c6a2af1d d335bf0ca9 _054b41f11b","slideImage":"_386df1c8da"};